// theme.js
import { createTheme } from '@mui/material/styles';

const theme = createTheme({
    components: {
        MuiContainer: {
            defaultProps: {
                disableGutters: true,   // ← xs(0–599 px) 구터 OFF
                maxWidth: false,        // ← 기본 폭 제한 없음
            },
        },
    },
});

export default theme;
